import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLifeVest: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLifeVest"><Path d="M12 7.5V12.5M12 7.5C14.4853 7.5 16.5 5.48528 16.5 3V2V5.5C16.5 7.70914 18.2909 9.5 20.5 9.5V20.5H3.5V9.5C5.70914 9.5 7.5 7.70914 7.5 5.5V2V3C7.5 5.48528 9.51472 7.5 12 7.5ZM12 12.5V16.5M12 12.5H9.5M12 12.5H14.5M12 16.5V20.5M12 16.5H3.5M12 16.5H20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLifeVest;
